<template>
  <div class="label__main">
    <div class="label__title" v-if="title" v-html="title"></div>
    <div class="label__content" v-html="content"></div>
    <div class="label__doc" v-if="doc">
      <span v-html="'&#57347;'"></span>
      <div v-html="doc"></div>
    </div>
  </div>
</template>

<style scoped>
.label__main {
  width: 100%;
  background-color: #ffffff;
}

.label__main > div {
  padding: 20px;
}

.label__title {
  text-transform: uppercase;
}

.label__doc {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #000000;
  font-size: 10px;
}

.label__doc > * {
  width: 50%;
}

@media screen and (max-width: 960px) {
  .label__main {
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  .label__doc {
    font-size: 10px;
  }

  .label__doc span {
    padding-bottom: 20px;
    width: 100%;
  }

  .label__doc div {
    width: 100%;
  }
}
</style>

<script>
export default {
  name: "Label",
  props: {
    title: String,
    content: String,
    doc: String
  }
};
</script>
